import { $ } from '../utils/Utils';

const silentScroll = (() => {
  const config = {
    triggers: [...$('.js-silentScrollTo')],
    focusCN: '-accessibilityFocus',
  };

  const handleClick = ({ e, trigger }) => {
    const { href } = trigger;
    const ID = href.slice(href.indexOf('#'));
    const target = document.querySelector(ID);

    // we don't want it to add any hash to the URL
    e.preventDefault();

    // and we want to scroll to target
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      target.focus();
      target.classList.add(config.focusCN);

      target.addEventListener('animationend', () => {
        target.classList.remove(config.focusCN);
      });
    }
  };

  const removeFocus = () => {
    config.triggers[0].blur();
  };

  const updateFocus = trigger => removeFocus(trigger);

  const handleScroll = (trigger) => {
    // Scroll window to top and listen for scroll event
    trigger.addEventListener('focus', () => {
      window.scrollTo(0, 0);

      setTimeout(() => {
        window.addEventListener('scroll', updateFocus);
      }, 0);
    });
    // remove focus state on scroll
    trigger.addEventListener('blur', () => {
      window.removeEventListener('scroll', updateFocus);
    });
  };

  const build = () => {
    config.triggers.forEach((trigger) => {
      trigger.addEventListener('click', e => handleClick({ e, trigger }));

      handleScroll(trigger);
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default silentScroll.init();
